var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFuriaAvatar = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 266,
    viewBox: "0 0 266 266",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "furia-avatar-a",
    cx: 112,
    cy: 112,
    r: 112
  }), /*#__PURE__*/React.createElement("filter", {
    id: "furia-avatar-b",
    width: "131.2%",
    height: "131.2%",
    x: "-15.6%",
    y: "-11.6%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "dilate",
    radius: 2,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 9.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.264662591 0"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "furia-avatar-d",
    points: ".611 .237 70.655 .237 70.655 214.676 .611 214.676"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "furia-avatar-f",
    points: ".439 .774 36.989 .774 36.989 13.335 .439 13.335"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "furia-avatar-h",
    points: "0 .774 36.551 .774 36.551 13.335 0 13.335"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(21 12)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "furia-avatar-c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#furia-avatar-a"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#furia-avatar-b)",
    xlinkHref: "#furia-avatar-a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F7F7FA",
    stroke: "#DEDEDE",
    strokeWidth: 4,
    xlinkHref: "#furia-avatar-a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#furia-avatar-c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(34 33)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BD3339",
    d: "M138.620176,97 L149,175.593744 L139.289686,211 C139.289686,211 90.2716919,205.197608 73.9877483,205.349228 C56.0771593,205.515427 6.61217833,210.777429 6.61217833,210.777429 L6,97 L138.620176,97 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2C2C2C",
    points: "122 147 112.856 147.42 77.499 149.045 42.144 147.42 33 147 36.706 158.486 41.919 183.669 44.643 184.27 49.852 200.287 44.295 217.164 42.399 222.927 37.633 237.404 42.028 262 72.59 262 75.46 255.042 78.744 255.042 82.322 262 82.8 262 112.972 262 117.367 237.403 112.601 222.927 110.704 217.164 105.148 200.287 110.359 184.263 113.056 183.669 118.278 158.445"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BD3339",
    points: "38.237 184.679 52.623 186 62 178 52.397 184.903 35 180.414 35.519 184.101"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BD3339",
    points: "104.763 184.679 90.377 186 81 178 90.603 184.903 108 180.414 107.481 184.101"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BD3339",
    points: "75.768 183.604 81 158 74 184"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DB3D35",
    points: "78.508 144.512 78.492 144.504 78.494 144.488"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DB3D35",
    points: "75.492 165.488 75.508 165.512 75.492 165.506"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DB3D35",
    points: "16.492 144.512 16.506 144.488 16.508 144.504"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DB3D35",
    points: "19.508 165.488 19.508 165.506 19.492 165.512"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C2C2C",
    d: "M23.5680199,189.061532 L16.1324253,190.137187 L27.7651865,181.599112 L36.4162899,158.434071 L41.6659212,183.503168 L44.4093587,184.101836 L49.6560611,200.046845 L53.8053884,212.360909 L23.5680199,189.061532 Z M42.0300857,261 L37.6034856,236.530544 L45.0215066,214.274699 L110.232335,214.274699 L105.343939,199.821979 L110.591618,183.984049 L113.307718,183.447682 L118.566137,158.364956 L127.233837,181.58451 L138.867575,190.130373 L131.43198,189.057638 L102.531183,212.214892 L103.720332,218.006882 L148,191.316028 L137.489022,167.543557 L122.315176,147 L113.105622,147.418581 L77.4985355,149.035471 L41.8934019,147.418581 L32.6838479,147 L17.510002,167.544531 L7,191.316028 L52.8964417,218.814841 L37.3506208,236.755409 L41.7762445,261 L62.2954003,261 L42.0300857,261 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD6A6",
    d: "M66.9181959 210.898174C73.6895267 212.996121 78.0973438 218.099753 76.7613182 222.298519 75.4262629 226.497286 68.8538321 228.199773 62.0825013 226.101826 55.3102002 224.003879 50.9033534 218.89929 52.2384087 214.701481 53.5744343 210.502714 60.1468651 208.800227 66.9181959 210.898174M87.9302259 210.998408C81.1750732 213.203827 76.8501397 218.350437 78.2697149 222.494152 79.6883164 226.636917 86.314948 228.207327 93.0701007 226.000957 99.8242798 223.795539 104.149213 218.648929 102.730612 214.506164 101.311037 210.3634 94.6853787 208.79299 87.9302259 210.998408"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2B99A",
    d: "M19,74 C13.4299674,74.4079074 9,78.9768563 9,84.5178399 L9,102.48216 C9,108.023144 13.4299674,112.592093 19,113 L19,74 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB3D35",
    d: "M11,58 C11,58 -2.21154633,193.268216 1.73645765,203 L11,153.848344 L11,58 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB3D35",
    d: "M21,58.7623129 C21,54.276438 14.7709672,53.5591239 13.8052983,57.9327068 C8.15566678,83.5285242 1.7166244,118.077699 4.79926438,131 C4.79926438,131 6.86654575,67.5462639 18.7067709,62.2443353 C20.0737079,61.6325371 21,60.3014888 21,58.7623129 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB3D35",
    d: "M27,20 C12.4349983,22.2176627 2.47195819,92.6379063 1,114 C1,114 12.4537055,48.2788351 22.1194002,51.9675053 L27,20 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2B99A",
    d: "M77.4990321,7 C46.8034078,7 21.6573956,28.7717318 19.2213119,56.4521566 L19.0437011,56.4521566 L19.0437011,56.4861536 L19.2174297,56.4861536 C19.2048126,56.625056 19.184431,56.7620157 19.1737549,56.900918 L19.0437011,56.9018894 L19.0437011,56.9863964 L19.0437011,124.887313 C19.0437011,124.887313 17.0899814,132.897997 39.3088111,144.151031 L66.899642,158.8368 C66.899642,158.8368 77.1544864,164.178227 89.1184717,158.074294 L124.766819,138.810575 C124.766819,138.810575 134.721763,135.157346 135.872837,124.747439 L135.998038,124.649333 L135.998038,123.169974 L135.998038,56.9018894 L135.998038,56.6046578 C136,56.5648326 136.00192,56.5250074 135.998038,56.4861536 L135.998038,56.4521566 C133.561954,28.7707604 108.194656,7 77.4990321,7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2B99A",
    d: "M136,74 C141.570033,74.4079074 146,78.9768563 146,84.5178399 L146,102.48216 C146,108.023144 141.570033,112.592093 136,113 L136,74 Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "furia-avatar-e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#furia-avatar-d"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DB3D35",
    d: "M0.706012329,83.6474458 L0.61069726,83.0509792 L0.679752055,84.9034202 C0.49690274,93.2132184 0.725464384,101.741236 1.27693014,110.309988 C1.45783425,113.125504 1.68347808,115.9449 1.92954658,118.761387 L0.61069726,214.676127 L12.4569986,206.223758 C3.42054658,-32.4957562 69.1646014,40.2906275 69.1646014,40.2906275 L70.6546288,4.66556829 C18.2906699,-15.5551346 1.95969726,37.41207 0.706012329,83.6474458",
    mask: "url(#furia-avatar-e)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DB3D35",
    d: "M150.671447 91.5140134L150.976773 83.2074348 150.618305 85.4682882C149.671409 38.586807 129.974039-13.9521329 80.5141818 4.95286138L76 40.5184569C76 40.5184569 149.408597-23.778857 136.312445 201.607405 136.312445 201.607405 136.677676 206.864979 137.069962 205.542355L138.202372 219 152 200.407749 149.932288 111.616727C150.387378 104.867088 150.651156 98.1387494 150.671447 91.5140134M72 34.2530828C72 34.2530828 9.30989827 6.35654391 17.690417 132 17.690417 132-3.30377682-2.11122121 72 34.2530828"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB3D35",
    d: "M85,16.4412211 C85,16.4412211 148.671243,21.4916113 139.135378,139 C139.135378,139 168.024813,-0.593326086 85,16.4412211"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB3D35",
    d: "M105 22.6198969C105 22.6198969 143.252773 53.5780508 135.161423 132 135.161423 132 154.862485 12.3969854 105 22.6198969M144 48C144 48 159.099268 153.108696 155.423279 200 155.423279 200 142.796745 52.4728339 144.198675 51.0144271 145.601623 49.555054 144 48 144 48"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB3D35",
    d: "M144 41C144 41 160.42426 143.409316 154.842983 165 154.842983 165 154.051183 80.6378737 144 78.071895L144 41zM79.1791322 131.071055C78.9390512 131.179747 78.3069391 131.558615 78 131.742873 77.6940739 131.558615 77.0609488 131.179747 76.8208678 131.071055 75.3216276 130.39199 72 134.80384 72 134.80384 76.1158197 135.419759 77.5350329 133.664129 78 132.927096 78.4659801 133.664129 79.8841803 135.491185 84 134.875266 84 134.875266 80.6783724 130.39199 79.1791322 131.071055"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB3D35",
    d: "M72,134.393375 C72,134.393375 77.711295,140.21323 84,134.460561 L78,132 L72,134.393375 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DB3D35",
    points: "67 4 88 4 75.992 40 74.281 34.944"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "44.237 184.679 58.623 186 68 178 58.397 184.903 41 180.413 41.519 184.101"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "110.763 184.679 96.377 186 87 178 96.603 184.903 114 180.413 113.481 184.101"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "113.768 183.604 119 158 112 184"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "41.232 183.604 36 158 43 184"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "49.358 200 104.51 200 106 204 48 203.929"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C2C2C",
    d: "M80.408595,136.371479 C81.0919008,136.560739 82.0082645,136.49912 82.0082645,137.167254 C82.0082645,137.836268 80.6833058,137.307218 80,137.495599 C80.157686,137.539613 81.3259504,138 81.4995041,138 C82.4267769,138 83,137.990317 83,137.167254 C83,136.34419 82.141157,136 81.2138843,136 C81.0403306,136 80.566281,136.328345 80.408595,136.371479 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#furia-avatar-c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(63 113)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(59.5 .076)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "furia-avatar-g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#furia-avatar-f"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0.438685,10.84005 C0.438685,10.84005 11.719885,-2.92315 30.672335,10.84005 C30.672335,10.84005 34.958885,13.5473 36.989535,13.32205 C36.989535,13.32205 32.251635,10.6148 28.866935,7.2301 C28.866935,7.2301 9.463135,-9.4656 0.438685,10.84005",
    mask: "url(#furia-avatar-g)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M70.58536,11.914875 C70.58536,14.295725 69.12081,16.226075 67.31371,16.226075 C65.50746,16.226075 64.04206,14.295725 64.04206,11.914875 C64.04206,9.534025 65.50746,7.603675 67.31371,7.603675 C69.12081,7.603675 70.58536,9.534025 70.58536,11.914875"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .076)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "furia-avatar-i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#furia-avatar-h"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M36.550765,10.84005 C36.550765,10.84005 25.269565,-2.92315 6.317115,10.84005 C6.317115,10.84005 2.030565,13.5473 -8.5e-05,13.32205 C-8.5e-05,13.32205 4.737815,10.6148 8.122515,7.2301 C8.122515,7.2301 27.526315,-9.4656 36.550765,10.84005",
    mask: "url(#furia-avatar-i)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M24.84703,10.800185 C24.84703,13.181035 26.31158,15.111385 28.11868,15.111385 C29.92578,15.111385 31.39033,13.181035 31.39033,10.800185 C31.39033,8.419335 29.92578,6.488985 28.11868,6.488985 C26.31158,6.488985 24.84703,8.419335 24.84703,10.800185"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFuriaAvatar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/furia-avatar.ad900652.svg";
export { ForwardRef as ReactComponent };